/**
 * @param Array[object] 传入的数组，每个元素都是一个对象。
 * @param String 需要对比的对象key
 * @param String 需要比对的字符串
 * @return Number
 */
export default (arr, key, str) => {
    for (let i = 0; i < arr.length; i++) {
        if (arr[i][key] === str) {
            return i
        }
    }

    return -1
}


// WEBPACK FOOTER //
// ./src/common/utils/indexWith.js